import Marquee from "react-fast-marquee";
import rajeev from "../directorimages/rajeevahuja.png";
import Ares from "../images/Ares.jpeg";
import easecruit from "../images/easecruit.png";
import Bodyloop from "../images/BODYLOOP_LABS.jpg";
import chematico from "../images/chematico.jpeg";
import dakters from "../images/Dakters.jpg";
import edith from "../images/edith_health.jpeg";
import epilepto from "../images/epilepto.png";
import evigway from "../images/evigway.jpeg";
import fulectronix from "../images/FULECTRONIX_TECHNOLOGY.jpg";
import greeninv from "../images/GREEN_INNOVOTECH.jpg";
import jyoma from "../images/JYOMA_SOLUTIONS.jpg";
import logier from "../images/logier.png";
import nanokriti from "../images/nanokriti.png";
import neontram from "../images/Neontram.jpg";
import renao from "../images/renao.jpg";
import rosch from "../images/rosch-crete.jpg";
import scratchnest from "../images/Scratchnest.png";
import wevixit from "../images/wevixit.jpeg";
import yoboshu from "../images/yoboshu.png";
import speedybyte from "../images/speedbyte1.png";
import { motion } from "framer-motion";
import vanix from "../images/vanix.png";
import citpeels from "../images/Citpeels.png";
import texoedge from "../images/Texoedge.jpg";
import yInstrument from "../images/Y Instrumentation.png";
import Fulectronics from "../images/Fulectronics.webp";
import Huskage from "../images/Huskage.png";
import MedXbid from "../images/MedXbid.png";
import SVIG from "../images/SVIG.webp";
import dronetech from "../images/dronetech.png";
import BEF from "../images/BFP.png";
import agniverse from "../images/agniverse.png";
import agb from "../images/agb solution.jpeg";
import ML from "../images/ML.png";
import DG from "../images/DG.png";
const marqueeData = [
  {
    img: Ares,
    name: ""
  },
  {
    img:  easecruit,
    name: ""
  },
  {
    img : speedybyte,
    name : "Speedybyte",
  },
  {
    img: Bodyloop,
    name: "name1"
  },
  {
    img: edith,
    name: "name1"
  },
  {
    img: scratchnest,
    name: "name1"
  },
  {
    img: vanix,
    name: "name1"
  },
  {
    img: yoboshu,
    name: "name1"
  },
  {
    img: logier,
    name: "name1"
  },
  {
    img: jyoma,
    name: "name1"
  },
  {
    img: greeninv,
    name: "name1"
  },
  {
    img: neontram,
    name: "name1"
  },
  {
    img: nanokriti,
    name: "name1"
  },
  {
    img: rosch,
    name: "name1"
  },
  {
    img: renao,
    name: "name1"
  },
  {
    img: fulectronix,
    name: "name1"
  },
  {
    img: evigway,
    name: "name1"
  },
  {
    img: epilepto,
    name: "name1"
  },
  {
    img: chematico,
    name: "name1"
  },
  
]


const startups = () => {
  return (
    <>
      <div className="w-full border-b border-gray-500 flex flex-col justify-center items-center pb-20">
        <div className="pt-10">
          <h1 className="text-center text-4xl font-bold text-black font-montserrat">
            <span className="text-blue-500 font-bold text-5xl">Our I</span>ncubatees
          </h1>
        </div>

        <div className="flex flex-wrap justify-center md:gap-10 gap-6 mt-20">
          {/* {marqueeData.map((data, i) => (
            <img
              key={i}
              src={data.img}
              alt={data.name}
              className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-400 border border-gray-300"
            />
            
          ))} */}
          <div >
            <img src={Ares} alt="" className="w-32 h-32 object-contain hover:shadow-sm hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-1">Ares</div>
          </div>
          <div>
            <img src={easecruit} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2">EaseCruit</div>
          </div>
          <div className=" border-gray-400 px-2 py-2 rounded-2xl">
            <img src={speedybyte} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">SpeedyByte</div>
          </div>

          <div>
            <img src={Bodyloop} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2">Bodyloop Labs</div>
          </div>
          <div>
            <img src={edith} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Edith HealthCare</div>
          </div>
          <div>
            <img src={scratchnest} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Scratch nest</div>
          </div>
          <div>
            <img src={vanix} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Vanix</div>
          </div>
          <div>
            <img src={yoboshu} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Yoboshu</div>
          </div>
          <div>
            <img src={logier} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Logier</div>
          </div>
          <div>
            <img src={jyoma} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Jyoma</div>
          </div>
          <div>
            <img src={greeninv} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Green Inv</div>
          </div>
          <div>
            <img src={neontram} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Neontram</div>
          </div>
          <div>
            <img src={nanokriti} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">NanoKriti</div>
          </div>
          <div>
            <img src={rosch} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Rosch</div>
          </div>
          <div>
            <img src={renao} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Renao</div>
          </div>
          {/* <div>
            <img src={fulectronix} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Fulectronix</div>
          </div> */}
          <div>
            <img src={evigway} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Evigway</div>
          </div>
          <div>
            <img src={epilepto} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Epilepto</div>
          </div>
          <div>
            <img src={chematico} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Chematico</div>
          </div>
          <div>
            <img src={citpeels} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">CitPeels</div>
          </div>
          <div>
            <img src={texoedge} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">TexoEdge</div>
          </div>
          <div>
            <img src={yInstrument} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Y Instrumentation</div>
          </div>
          <div>
            <img src={Fulectronics} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Fulectronix</div>
          </div>
          <div>
            <img src={Huskage} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Huskage</div>
          </div>
          <div>
            <img src={MedXbid} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">MedXbid</div>
          </div>
          <div>
            <img src={SVIG} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">SVM</div>
          </div>
          <div>
            <img src={dronetech} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Drones Tech</div>
          </div>
          <div>
            <img src={BEF} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">BEF</div>
          </div>
          <div>
            <img src={agniverse} alt="" className="w-32 px-2 pt-3 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Agniverse</div>
          </div>
          <div>
            <img src={agb} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">AGB Solutions</div>
          </div>
          <div>
            <img src={ML} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">ML workX</div>
          </div>
          <div>
            <img src={DG} alt="" className="w-32 h-32 object-contain hover:shadow-lg hover:shadow-blue-300 border rounded-xl border-gray-400" />
            <div className="flex justify-center pt-2 pb-2 ">Dg</div>
          </div>

        </div>
      </div>
    </>
  );
};

export default startups;


{/* <h1 className=" text-center text-4xl font-bold text-black font-montserrat "><span className="text-blue-500 font-bold text-5xl">Our I</span>ncubatees</h1>
        <Marquee speed={100} className="h-full w-full overflow-y-hidden">
          {marqueeData.map((data, i) => (
            <div className="h-[20vh] w-full flex flex-col  items-center justify-center p-3">
              <img
                src={data.img}
                alt="Image"
                className="w-full h-full border-black object-cover hover:shadow-lg hover:shadow-orange-400 hover:rounded-full"
              />
              {/* <span className="text-black">{data.name}</span> */}
            {/* </div>
          ))}
        </Marquee> */}
        {/* <Marquee
          direction="right"
          speed={80}
          className="h-2/5 marq1 mt-8 overflow-y-hidden"
        >
          {imagedata2.map((data, i) => (
            <div key={i} className="image_wrapper mx-[30px] h-full ">
              <img
                src={data}
                className="h-[200px] lg:h-[300px] object-contain"
              ></img>
            </div>
          ))}
        </Marquee> */}